import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { withEventScope } from '@repo/event-processor';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import TeamCreationBannerComponent from 'components/TeamCreationBanner/TeamCreationBanner';
import { useTeamAccountsFeature } from 'global/growthbookUtils';

export type TeamCreationBannerProps =
  SliceComponentProps<Content.TeamCreationBannerSlice>;

const TeamCreationBanner = (): JSX.Element | null => {
  const teamsEnabled = useTeamAccountsFeature();
  if (!teamsEnabled) {
    return null;
  }

  return (
    <ContentWrapper className="team-creation-banner" customWidth="888px">
      <TeamCreationBannerComponent />
    </ContentWrapper>
  );
};

export default withEventScope(TeamCreationBanner, {
  module: 'teamCreationBanner',
});
